import { EndCustomerCircuit, IspCircuit } from 'src/app/_share/_models/schema';
import { NetworkPortalProducts } from './network-portal-products.model';
import { NetworkServicesChangeLog } from './network-services-change-log.model';

export interface NetworkServices {
  id?: number;
  service_status: string;
  date_activated: Date;
  date_suspended?: Date;
  date_cancelled?: Date;
  date_upgraded?: Date;
  date_downgraded?: Date;
  date_relocated?: Date;
  date_device_modified?: Date;
  recurring_product_id?: number;
  recurring_product?: NetworkPortalProducts;
  change_logs?: NetworkServicesChangeLog[];
  end_customer_circuit?: EndCustomerCircuit[];
  isp_circuit?: IspCircuit[];
  customer_id?: number;
  customer_name?: string;
  device_serial_number?: string;
  device_model?: string;
  service_address?: string;
  billing_address?: string;
  contact_phone?: string;
  contact_email?: string;
  bandwidth_mbps?: number;
  ip_address?: string;
  vlan_id?: string;
  contract_end_date?: Date;
  auto_renewal?: boolean;
  notes?: string;
  created_by?: string;
  created_date?: Date;
  modified_by?: string;
  modified_date?: Date;
}

export interface NetworkSeviceActions {
  date_actioned?: Date;
  circuit_no?: string;
  recurring_product_id?: number;
  device_serial_number?: string;
  // reason_comments?: string;
  effective_date?: Date;
  request_date?: Date;
}

export interface ServiceCreationRequest {
  date_activated?: string;
  circuit_no?: string;
  recurring_product_id?: number;
  device_serial_no?: string;
}

export interface ServiceModificationRequest {
  id?: number;
  service_id: number;
  action_type: ServiceActionType;
  request_date: Date;
  effective_date: Date;
  reason_comments: string;
  new_product_id?: number;
  new_bandwidth_mbps?: number;
  new_ip_address?: string;
  new_vlan_id?: string;
  new_service_address?: string;
  new_billing_address?: string;
  new_device_serial_number?: string;
  new_device_model?: string;
  new_contact_phone?: string;
  new_contact_email?: string;
  auto_renewal?: boolean;
  contract_end_date?: Date;
  created_by: string;
  status: ServiceRequestStatus;
  approved_by?: string;
  approved_date?: Date;
  rejected_reason?: string;
}

export enum ServiceActionType {
  MODIFICATION = 'modification',
  SUSPENSION = 'suspension',
  REACTIVATION = 'reactivation',
  CANCELLATION = 'cancellation',
  REGRADE_UPGRADE = 'regrade_upgrade',
  REGRADE_DOWNGRADE = 'regrade_downgrade',
  DEVICE_MODIFICATION = 'device_modification',
  RELOCATION = 'relocation',
  BANDWIDTH_CHANGE = 'bandwidth_change',
  IP_ADDRESS_CHANGE = 'ip_address_change',
  VLAN_CHANGE = 'vlan_change',
  CONTACT_UPDATE = 'contact_update',
  ADDRESS_UPDATE = 'address_update',
  CONTRACT_UPDATE = 'contract_update'
}

export enum ServiceRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export interface ServiceTimelineEvent {
  id: number;
  service_id: number;
  event_type: ServiceActionType;
  event_date: Date;
  description: string;
  performed_by: string;
  details?: Record<string, unknown>;
  change_log_id?: number;
}
